module.exports = __webpack_public_path__ + "static/media/rejected_icon.b3a3d9d6.png";